/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Modal, Box, Typography, IconButton } from '@mui/material'
import { MdOutlineCreditCardOff } from 'react-icons/md'
import { InputButton, Loading } from '../../Simple'
import { RiDeleteBinLine } from 'react-icons/ri'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { AuthContext } from '../../../contexts/AuthContext'
import NewCredCard from './NewCredCard'
import CloseIcon from '@mui/icons-material/Close'

import 'react-credit-cards-2/dist/es/styles-compiled.css'
import './stylesMSCC.css'

export default function AddCredCard({ modal, ClosedModal, mode }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { sttCtxChkt, loadCh, actionsChkt } = React.useContext(CheckoutContext)

  const [sttMd, setSttMd] = React.useState({
    state: false,
    mode: mode,
    cartoes: [],
    cardSel: null,
  })

  React.useEffect(() => {
    actionsChkt.BuscarCartoesAtivos(false).then(res => {
      if (res) {
        setSttMd(sttMd => ({ ...sttMd, cartoes: res }))
      }
    })
  }, [])

  function RemoveCreditCard(idcard) {
    actionsChkt.RemoveCreditCard(idcard).then(res => {
      if (res) {
        // remove o cartão da lista de cartões
        let cartoes = sttMd.cartoes.filter(item => item.idcard !== idcard)
        setSttMd(sttMd => ({ ...sttMd, cartoes: cartoes }))
      }
    })
  }

  function Cartao({ item }) {
    return (
      <div className='contain-btt-modal-cartao'>
        {mode === 'select-card' && (
          <input
            type='radio'
            name='cartao'
            checked={sttCtxChkt.cardSelected?.idcard === item.idcard ? true : false}
            className='input-radio-cartao'
            onChange={() => {
              if (item.idcard === sttCtxChkt.cardSelected?.idcard) {
                actionsChkt.selectModePay('card', null)
              } else {
                actionsChkt.selectModePay('card', item)
              }
            }}
            onClick={() => {
              if (item.idcard === sttCtxChkt.cardSelected?.idcard) {
                actionsChkt.selectModePay('card', null)
              } else {
                actionsChkt.selectModePay('card', item)
              }
            }}
          />
        )}
        <button
          className='btt-modal-cartao'
          onClick={e => {
            if (item.idcard === sttCtxChkt.cardSelected?.idcard) {
              actionsChkt.selectModePay('card', null)
            } else {
              actionsChkt.selectModePay('card', item)
            }
            e.stopPropagation()
          }}
        >
          <h2 className='rotulo-cartao'>{item.metodo}</h2>
          <h2 className='rotulo-cartao-mid'>**** **** **** {item.numero}</h2>
          <h2 className='rotulo-cartao-hig'>{item.nome}</h2>
          <button
            className='contain-btt-excluir-cc'
            onClick={e => {
              RemoveCreditCard(item.idcard)
              e.stopPropagation()
            }}
          >
            <RiDeleteBinLine size={25} />
            <h2>Excluir Cartão</h2>
          </button>
        </button>
      </div>
    )
  }

  return (
    <Modal open={modal} className='contain-overlay-sel-cc' onClose={ClosedModal}>
      <Box className='contain-content-sel-cc'>
        <IconButton
          sx={{ position: 'absolute', top: '10px', right: '10px' }}
          onClick={() => {
            sttMd.mode === 'add-new-card' ? setSttMd({ ...sttMd, mode: mode }) : ClosedModal()
          }}
        >
          <CloseIcon color='primary' />
        </IconButton>
        {sttMd.mode === 'select-card' ? (
          <div className='contain-captura-cc'>
            <Typography variant='h6' fontWeight='bold' align='left'>
              Selecione um cartão
            </Typography>
            <div className='contain-lista-cartaos'>
              {loadCh.cartaoCredito ? (
                <div className='contain-loading'>
                  <Loading text={'Carregando seus cartões....'} />
                </div>
              ) : sttMd.cartoes.length ? (
                sttMd.cartoes.map((item, index) => {
                  return <Cartao key={index} item={item} />
                })
              ) : (
                !sttAuthCtx.isMobile && (
                  <>
                    <MdOutlineCreditCardOff size={100} color={'gray'} />
                    <h2>Nenhum cartão de crédito cadastrado ainda</h2>
                  </>
                )
              )}
            </div>
            <InputButton
              onClick={() => {
                setSttMd({ ...sttMd, mode: 'add-new-card' })
              }}
              variant='contained'
              sx={{ maxWidth: '350px', my: 1 }}
            >
              Adicionar um cartão
            </InputButton>
            <InputButton
              onClick={() => {
                ClosedModal()
              }}
              variant='outlined'
              sx={{ maxWidth: '350px' }}
            >
              Fechar
            </InputButton>
          </div>
        ) : (
          <NewCredCard
            ClosedModal={ClosedModal}
            handleMode={() => {
              setSttMd({ ...sttMd, mode: 'select-card' })
            }}
          />
        )}
      </Box>
    </Modal>
  )
}
